var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaDropIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.456 1.59082H6.54688C4.0616 1.59082 2.04688 3.60553 2.04688 6.09082V37.909C2.04688 40.3943 4.0616 42.409 6.54688 42.409H51.456C53.9412 42.409 55.956 40.3943 55.956 37.909V6.09082C55.956 3.60554 53.9412 1.59082 51.456 1.59082Z",
    stroke: "#0e0333",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0234 23.6629L24.5689 32.0083C23.5689 32.5856 22.3189 31.8639 22.3189 30.7092L22.3189 14.0186C22.3189 12.8639 23.5689 12.1422 24.5689 12.7195L39.0234 21.0649C40.0234 21.6422 40.0234 23.0856 39.0234 23.6629Z",
    stroke: "#0e0333",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaDropIcon);
export default __webpack_public_path__ + "static/media/media-drop-icon.093970ff74890aafe34f14f4941ce89f.svg";
export { ForwardRef as ReactComponent };